import { Post as PostType } from "../../types/post";

export interface initialValuesI {
  imageUrl: string;
  imageAlt: string;
  title: string;
  shortDescription: string;
  seoTitle: string;
  seoKeyword: string;
  seoDesctiption: string;
  url: string;
  similarArticles: string[];
  status: string;
  language: string;
  topic: string;
  tags: string[];
}

export interface initialValuesEditI {
  _id: string;
  imageUrl: string;
  imageAlt: string;
  title: string;
  shortDescription: string;
  seoTitle: string;
  seoKeyword: string;
  seoDesctiption: string;
  url: string;
  similarArticles: [] | string[];
  status: string;
  language: string;
  topic: string;
  tags: string[];
  createdAt: string;
  updatedAt: string;
}

export const initialValues = (): initialValuesI => ({
  imageUrl: "",
  imageAlt: "",
  title: "",
  shortDescription: "",
  seoTitle: "",
  seoKeyword: "",
  seoDesctiption: "",
  url: "",
  similarArticles: [],
  status: "",
  language: "",
  topic: "",
  tags: [],
});

export const initialValuesEdit = (
  post: PostType | null
): initialValuesEditI => ({
  _id: post?._id ?? "",
  imageUrl: post?.imageUrl ?? "",
  imageAlt: post?.imageAlt ?? "",
  title: post?.title ?? "",
  shortDescription: post?.shortDescription ?? "",
  seoTitle: post?.seoTitle ?? "",
  seoKeyword: post?.seoKeyword ?? "",
  seoDesctiption: post?.seoDesctiption ?? "",
  url: post?.url ?? "",
  similarArticles: post?.similarArticles.map((item) => item._id) ?? [],
  status: post?.status ?? "",
  language: post?.language ?? "",
  topic: post?.topic ?? "",
  tags: post?.tags ?? [],
  createdAt: post?.createdAt ?? "",
  updatedAt: post?.updatedAt ?? "",
});
